import React, { useEffect, useState } from 'react';
import { getGameData } from '../services/service';

const typeColor = {
  object: '#a855f7',
  array: '#06b6d4',
  string: '#22c55e',
  number: '#3b82f6',
  boolean: '#f59e0b',
  null: '#64748b',
};

const btnStyle = {
  fontSize: '1rem',
  padding: '2px 10px',
  cursor: 'pointer',
  borderRadius: '4px',
  border: 'none',
  background: 'lightgreen',
  color: '#2c974b',
  lineHeight: 1,
  transition: 'background 0.2s ease',
};

const btnHoverStyle = {
  background: 'rgb(128, 206, 150)',
};

const renderValue = (val) => {
  if (typeof val === 'string') return `"${val}"`;
  if (val === null) return 'null';
  return String(val);
};

const DebugTreeNode = ({ data, name = 'data', path = 'data' }) => {
  const [buttonText, setButtonText] = useState({
    pathButton: '📍',  // Use icon for default text
    valueButton: '⧉',  // Use icon for default text
  });
  const [expanded, setExpanded] = useState(false);
  const [hoveredBtn, setHoveredBtn] = useState(null);

  const isObject = typeof data === 'object' && data !== null;
  const isArray = Array.isArray(data);
  const isExpandable = isObject;
  const type = isArray ? 'array' : typeof data === 'object' ? 'object' : typeof data;

  const toggle = () => {
    if (isExpandable) setExpanded(!expanded);
  };

  const copyToClipboard = (e, text, msg, buttonType) => {
    setButtonText((prevState) => ({
      ...prevState,
      [buttonType]: '✔️', // Change button text to checkmark
    }));

    navigator.clipboard.writeText(text).then(() => {
      //console.log(msg);
      // Revert back to original icon after 1 second
      setTimeout(() => {
        setButtonText((prevState) => ({
          ...prevState,
          [buttonType]: buttonType === 'pathButton' ? '📍' : '⧉', // Reset to original icon
        }));
      }, 1000);
    });
  };

  return (
    <div style={{ marginLeft: 16 }}>
      <div
        onClick={toggle}
        style={{
          cursor: isExpandable ? 'pointer' : 'default',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          flexWrap: 'wrap',
        }}
      >
        {isExpandable ? (expanded ? '-' : '+') : ''}{' '}
        <strong>{name}</strong>

        <span
          style={{
            fontSize: '0.65rem',
            background: typeColor[type],
            color: 'white',
            padding: '1px 6px',
            borderRadius: 6,
          }}
        >
          {type}
        </span>

        {(
          <>
            <span>{!isExpandable ? renderValue(data) : ''}</span>

            <div style={{ display: 'flex', gap: 4 }}>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(e, path, 'Path copied', 'pathButton');
                }}
                title="Copy JSON path"
                onMouseEnter={() => setHoveredBtn('path')}
                onMouseLeave={() => setHoveredBtn(null)}
                style={{
                  ...btnStyle,
                  ...(hoveredBtn === 'path' ? btnHoverStyle : {}),
                }}
              >
                {buttonText.pathButton}
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(e, JSON.stringify(data), 'Value copied', 'valueButton');
                }}
                title="Copy value"
                onMouseEnter={() => setHoveredBtn('value')}
                onMouseLeave={() => setHoveredBtn(null)}
                style={{
                  ...btnStyle,
                  ...(hoveredBtn === 'value' ? btnHoverStyle : {}),
                }}
              >
                {buttonText.valueButton}
              </button>
            </div>
          </>
        )}
      </div>

      {expanded &&
        isObject &&
        Object.entries(data).map(([key, val]) => (
          <DebugTreeNode
            key={key}
            name={key}
            data={val}
            path={`${path}.${key}`}
          />
        ))}
    </div>
  );
};

const DebugTree = () => {

	const [data, setData] = useState({});

	useEffect(() => {
		getGameData().then(data => {
			setData(data);
		})
	}, [])


  return (
    <div style={{ fontFamily: 'monospace', fontSize: '0.9rem', lineHeight: 1.6 }}>
      <DebugTreeNode data={data} />
    </div>
  );
};

export default DebugTree;
